import { YammerI18nState, getCurrentLocale, isCurrentLocaleRTL } from '@ms/yammer-i18n-react';
import { MapStateToProps, connect } from 'react-redux';

import AppDocumentLanguage, { AppDocumentLanguageProps } from './AppDocumentLanguage';

export const mapStateToProps: MapStateToProps<AppDocumentLanguageProps, Record<string, unknown>, YammerI18nState> = (
  state
) => {
  const lang = getCurrentLocale(state);
  const dir = isCurrentLocaleRTL(state) ? 'rtl' : 'ltr';

  return {
    lang,
    dir,
  };
};

export default connect(mapStateToProps)(AppDocumentLanguage);
